import { SecretariaMedico } from '@/types/interfaces/CadastroMedico'
import { CadastroMedico, ICadastroMedicoMessage, Secretaria, ISecretariaMedicoMessage, ISnackbarValidation } from '@/types/_'
import { validateEmail } from '@/utils/common'


export class CadastroMedicoValidation {
  isValid(cadastroMedico: CadastroMedico, secretariaMedico: SecretariaMedico[]) {
    const cadastroMedicoValidation: ICadastroMedicoMessage = {
      assinatura: '',
      celular: '',
      cpf: '',
      conselhoTipo: 'CRM',
      conselhoNumero: '',
      conselhoUf: '',
      dataNascimento: null,
      email: '',
      especialidades: '',
      hospitais: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    }

    const messageText = 'Por favor informe'

    if (cadastroMedico.celular === '' || cadastroMedico.celular.toString().length < 10) {
      cadastroMedicoValidation.celular = `${messageText} o celular de contato.`
      cadastroMedicoValidation.total += 1
    }
    if (cadastroMedico.cpf === '' || cadastroMedico.cpf.toString().length < 11) {
      cadastroMedicoValidation.cpf = `${messageText} o cpf.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.conselhoNumero === '') {
      cadastroMedicoValidation.conselhoNumero = `${messageText} o número do documento.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.conselhoUf === '') {
      cadastroMedicoValidation.conselhoUf = `${messageText} a UF do documento.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.sexo === '') {
      cadastroMedicoValidation.sexo = `${messageText} o sexo.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.conselhoNumero === '') {
      cadastroMedicoValidation.conselhoNumero = `${messageText} o número do documento.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.conselhoUf === '') {
      cadastroMedicoValidation.conselhoUf = `${messageText} a UF do documento.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.email === '') {
      cadastroMedicoValidation.email = `${messageText} o email.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const result = re.test(cadastroMedico.email)

      if (!result) {
        cadastroMedicoValidation.email = `${messageText} o email corretamente.`
        cadastroMedicoValidation.total += 1
      }
    }

    if (!cadastroMedico.assinatura) {
      cadastroMedicoValidation.assinatura = 'Por favor, envie a assinatura do médico.'
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.especialidades.length === 0) {
      cadastroMedicoValidation.especialidades = `${messageText} a(s) especialidade(s).`
      cadastroMedicoValidation.total += 1
    }

    if (secretariaMedico.length === 1) {
      if (secretariaMedico[0].nome || secretariaMedico[0].email) {
        if (secretariaMedico[0].nome) {
          // eslint-disable-next-line
          secretariaMedico[0].nomeMensagem = ''
        } else {
          // eslint-disable-next-line
          secretariaMedico[0].nomeMensagem = `${messageText} o nome.`
        }
        if (validateEmail(secretariaMedico[0].email)) {
          if (secretariaMedico[0].email === cadastroMedico.email) {
            // eslint-disable-next-line
            cadastroMedicoValidation.email = 'Email duplicado.'
            // eslint-disable-next-line
            secretariaMedico[0].mensagem = 'Email duplicado.'
            cadastroMedicoValidation.total += 1
          } else {
            // eslint-disable-next-line
            secretariaMedico[0].mensagem = ''
          }
        } else {
          // eslint-disable-next-line
          secretariaMedico[0].mensagem = 'Email inválido.'
          cadastroMedicoValidation.total += 1
        }
      } else {
        // eslint-disable-next-line
        secretariaMedico[0].mensagem = ''
        // eslint-disable-next-line
        secretariaMedico[0].nomeMensagem = ''
      }
    }

    if (secretariaMedico.length > 1) {
      secretariaMedico.map((p) => {
        const s = p
        if (s.nome) {
          s.nomeMensagem = ''
        } else {
          s.nomeMensagem = `${messageText} o nome.`
        }

        if (validateEmail(s.email)) {
          if (secretariaMedico.filter(d => d.email === s.email).length > 1) {
            s.mensagem = 'Email duplicado.'
            cadastroMedicoValidation.total += 1
          } else if (secretariaMedico.some(d => d.email === cadastroMedico.email)) {
            cadastroMedicoValidation.email = 'Email duplicado.'
            s.mensagem = 'Email duplicado.'
            cadastroMedicoValidation.total += 1
          } else {
            s.mensagem = ''
          }
        } else {
          s.mensagem = 'Email inválido.'
          cadastroMedicoValidation.total += 1
        }
        return s
      })
    }

    // eslint-disable-next-line
    secretariaMedico.map((p) => {
      if (p.nome || p.email) {
        if (p.assinarEnviar === null) {
          // eslint-disable-next-line
          p.assinarEnviarMensagem = `${messageText} o campo assinar e enviar.`
          cadastroMedicoValidation.total += 1
        } else {
          // eslint-disable-next-line
          p.assinarEnviarMensagem = ''
        }
      } else {
        // eslint-disable-next-line
        p.assinarEnviarMensagem = ''
      }
    })

    cadastroMedicoValidation.success = cadastroMedicoValidation.total <= 0

    return cadastroMedicoValidation
  }
}

export class SecretariaMedicoValidation {
  formMedicoSecretariaValidate(secretariasMedico: SecretariaMedico[], email: string) {
    const validation: ISnackbarValidation = {
      success: true,
      total: 0,
    }

    const messageText = 'Por favor informe'

    secretariasMedico.map((p) => {
      const s = p
      if (validateEmail(s.email)) {
        if (secretariasMedico.filter(d => d.email === s.email).length > 1) {
          s.mensagem = 'Email duplicado.'
          validation.total += 1
        } else if (secretariasMedico.some(d => d.email === email)) {
          s.mensagem = 'Email duplicado.'
          validation.total += 1
        } else {
          s.mensagem = ''
        }
      } else {
        s.mensagem = 'Email inválido.'
        validation.total += 1
      }

      return s
    })

    secretariasMedico.map((p) => {
      if (p.assinarEnviar === null) {
        // eslint-disable-next-line
        p.assinarEnviarMensagem = `${messageText} o campo assinar e enviar.`
        validation.total += 1
      } else {
        // eslint-disable-next-line
        p.assinarEnviarMensagem = ''
      }
      if (p.nome) {
        // eslint-disable-next-line
        p.nomeMensagem = ''
      } else {
        // eslint-disable-next-line
        p.nomeMensagem = `${messageText} o nome.`
        validation.total += 1
      }
      return p
    })

    validation.success = validation.total === 0

    return validation
  }

  isValid(cadastroMedico: CadastroMedico) {
    const cadastroMedicoValidation: ICadastroMedicoMessage = {
      assinatura: '',
      celular: '',
      cpf: '',
      conselhoTipo: 'CRM',
      conselhoNumero: '',
      conselhoUf: '',
      dataNascimento: null,
      email: '',
      especialidades: '',
      hospitais: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    }

    const messageText = 'Por favor informe'

    if (cadastroMedico.nome === '') {
      cadastroMedicoValidation.nome = `${messageText} o nome.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.sexo === '') {
      cadastroMedicoValidation.sexo = `${messageText} o sexo.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.celular === '' || cadastroMedico.celular.toString().length < 10) {
      cadastroMedicoValidation.celular = `${messageText} o celular de contato.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.cpf === '' || cadastroMedico.cpf.toString().length < 11) {
      cadastroMedicoValidation.cpf = `${messageText} o cpf.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.email === '') {
      cadastroMedicoValidation.email = `${messageText} o email.`
      cadastroMedicoValidation.total += 1
    }

    if (cadastroMedico.email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const result = re.test(cadastroMedico.email)

      if (!result) {
        cadastroMedicoValidation.email = `${messageText} o email corretamente.`
        cadastroMedicoValidation.total += 1
      }
    }
    cadastroMedicoValidation.success = cadastroMedicoValidation.total === 0
    return cadastroMedicoValidation
  }

  private verifyFormMedicoSingle(secretariaMedico: SecretariaMedico) {
    if (secretariaMedico.email !== '') {
      return this.verifyFormMedico(secretariaMedico)
    }

    const secretariaMedicoValidation: ISecretariaMedicoMessage = {
      cpf: '',
      email: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    }

    return secretariaMedicoValidation
  }

  private verifySigle(secretaria: Secretaria) {
    if (secretaria.cpf !== ''
    || secretaria.email !== ''
    || secretaria.nome !== ''
    || secretaria.sexo !== '') {
      return this.verify(secretaria)
    }

    const secretariaMedicoValidation: ISecretariaMedicoMessage = {
      cpf: '',
      email: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    }

    return secretariaMedicoValidation
  }

  private verifyFormMedico(secretaria: SecretariaMedico) {
    const secretariaMedicoValidation: ISecretariaMedicoMessage = {
      cpf: '',
      email: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    }

    const messageText = 'Por favor informe'

    if (secretaria.email === '') {
      secretariaMedicoValidation.email = `${messageText} o email.`
      secretariaMedicoValidation.total += 1
    }

    if (secretaria.email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const result = re.test(secretaria.email)

      if (!result) {
        secretariaMedicoValidation.email = `${messageText} o email corretamente.`
        secretariaMedicoValidation.total += 1
      }
    }

    secretariaMedicoValidation.success = secretariaMedicoValidation.total <= 0
    return secretariaMedicoValidation
  }

  private verify(secretaria: Secretaria) {
    const secretariaMedicoValidation: ISecretariaMedicoMessage = {
      cpf: '',
      email: '',
      nome: '',
      sexo: '',
      success: true,
      total: 0,
    }

    const messageText = 'Por favor informe'

    if (secretaria.cpf === '' || secretaria.cpf.toString().length < 11) {
      secretariaMedicoValidation.cpf = `${messageText} o cpf.`
      secretariaMedicoValidation.total += 1
    }

    if (secretaria.email === '') {
      secretariaMedicoValidation.email = `${messageText} o email.`
      secretariaMedicoValidation.total += 1
    }

    if (secretaria.email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const result = re.test(secretaria.email)

      if (!result) {
        secretariaMedicoValidation.email = `${messageText} o email corretamente.`
        secretariaMedicoValidation.total += 1
      }
    }

    if (secretaria.nome === '') {
      secretariaMedicoValidation.nome = `${messageText} o nome.`
      secretariaMedicoValidation.total += 1
    }

    if (secretaria.sexo === '') {
      secretariaMedicoValidation.sexo = `${messageText} o sexo.`
      secretariaMedicoValidation.total += 1
    }

    secretariaMedicoValidation.success = secretariaMedicoValidation.total <= 0

    return secretariaMedicoValidation
  }
}

export default {
  CadastroMedicoValidation,
  SecretariaMedicoValidation,
}
